import { render, staticRenderFns } from "./ManagerSettings.vue?vue&type=template&id=c8930496&scoped=true"
import script from "./ManagerSettings.vue?vue&type=script&lang=js"
export * from "./ManagerSettings.vue?vue&type=script&lang=js"
import style0 from "./ManagerSettings.vue?vue&type=style&index=0&id=c8930496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8930496",
  null
  
)

export default component.exports